"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const bn_js_1 = __importDefault(require("bn.js"));
const borsh = __importStar(require("borsh"));
const web3_js_1 = require("@solana/web3.js");
class Assignable {
    constructor(properties) {
        Object.keys(properties).map((key) => {
            this[key] = properties[key];
        });
    }
}
class PubKey extends web3_js_1.PublicKey {
    constructor({ value }) {
        super(value);
    }
}
class OptionAddress extends web3_js_1.PublicKey {
    constructor({ value }) {
        super(value.slice(1, value.length));
    }
}
const PoolRequestTag = new bn_js_1.default('220a6cbdcd1cc4cf', 'hex');
class PoolRequestInner extends Assignable {
}
exports.PoolRequestInner = PoolRequestInner;
class InitializeFundData extends Assignable {
}
exports.InitializeFundData = InitializeFundData;
class InitializePoolRequest extends PoolRequestInner {
}
exports.InitializePoolRequest = InitializePoolRequest;
class PoolRequest extends Assignable {
}
exports.PoolRequest = PoolRequest;
class AssetInfo extends Assignable {
}
exports.AssetInfo = AssetInfo;
class ParamDesc extends Assignable {
}
exports.ParamDesc = ParamDesc;
class FundState extends Assignable {
}
exports.FundState = FundState;
class PoolState extends Assignable {
}
exports.PoolState = PoolState;
class ExecutePoolAction extends PoolRequestInner {
}
exports.schema = new Map([
    [
        PoolRequest,
        {
            kind: 'struct',
            fields: [
                ['tag', 'u64'],
                ['index', 'u8'],
                ['inner', PoolRequestInner],
            ],
        },
    ],
    [
        InitializePoolRequest,
        {
            kind: 'struct',
            fields: [
                ['nonce', 'u8'],
                ['assetsLength', 'u8'],
                ['poolName', 'string'],
                ['feeRate', 'u32'],
                ['customData', ['u8']],
            ],
        },
    ],
    [
        InitializeFundData,
        {
            kind: 'struct',
            fields: [
                ['slippageDivider', 'u64'],
                ['assetWeights', ['u32']],
                ['initialSupply', 'u64'],
            ],
        },
    ],
    [
        OptionAddress,
        {
            kind: 'struct',
            fields: [['value', [33]]],
        },
    ],
    [
        PubKey,
        {
            kind: 'struct',
            fields: [['value', [32]]],
        },
    ],
    [
        AssetInfo,
        {
            kind: 'struct',
            fields: [
                ['mint', PubKey],
                ['vaultAddress', PubKey],
            ],
        },
    ],
    [
        PoolState,
        {
            kind: 'struct',
            fields: [
                ['tag', 'u64'],
                ['poolTokenMint', PubKey],
                ['assets', [AssetInfo]],
                ['vaultSigner', PubKey],
                ['vaultSignerNonce', 'u8'],
                ['accountParams', [ParamDesc]],
                ['name', 'string'],
                ['lqdFeeVault', PubKey],
                ['initializerFeeVault', PubKey],
                ['feeRate', 'u32'],
                ['adminKey', OptionAddress],
                ['customState', ['u8']],
            ],
        },
    ],
    [
        ParamDesc,
        {
            kind: 'struct',
            fields: [
                ['address', PubKey],
                ['writable', 'u8'],
            ],
        },
    ],
    [
        FundState,
        {
            kind: 'struct',
            fields: [
                ['paused', 'u8'],
                ['slippageDivider', 'u64'],
                ['assetWeights', ['u32']],
                ['basicAsset', AssetInfo],
            ],
        },
    ],
    [
        ExecutePoolAction,
        {
            kind: 'struct',
            fields: [
                ['index', 'u8'],
                ['amount', 'u64'],
            ],
        },
    ],
]);
var PoolAction;
(function (PoolAction) {
    PoolAction[PoolAction["Create"] = 1] = "Create";
    PoolAction[PoolAction["Redeem"] = 2] = "Redeem";
})(PoolAction = exports.PoolAction || (exports.PoolAction = {}));
class Fund {
    constructor(connection, fundProgramId) {
        Object.assign(this, {
            connection,
            fundProgramId,
        });
    }
    static createInitializeInstruction(fundProgramId, fundAccount, fundTokenMint, fundVaultAccounts, fundVaultAuthority, lqdFeeAccount, initializerFeeAccount, sysvar, fundAdminAccount, initialSupplyFundTokenAccount, fundBasicTokenVaultAccount, tokenProgramId, nonce, poolName, feeRate, assetWeights, initialSupply, slippageDivider) {
        const keys = [
            { pubkey: fundAccount, isSigner: false, isWritable: true },
            { pubkey: fundTokenMint, isSigner: false, isWritable: true },
            ...fundVaultAccounts.map((acc) => ({ pubkey: acc, isSigner: false, isWritable: true })),
            { pubkey: fundVaultAuthority, isSigner: false, isWritable: false },
            { pubkey: lqdFeeAccount, isSigner: false, isWritable: false },
            { pubkey: initializerFeeAccount, isSigner: false, isWritable: false },
            { pubkey: sysvar, isSigner: false, isWritable: false },
            { pubkey: fundAdminAccount, isSigner: false, isWritable: true },
            { pubkey: initialSupplyFundTokenAccount, isSigner: false, isWritable: true },
            { pubkey: fundBasicTokenVaultAccount, isSigner: false, isWritable: false },
            { pubkey: tokenProgramId, isSigner: false, isWritable: false },
        ];
        const initializeFundData = new InitializeFundData({
            slippageDivider,
            assetWeights,
            initialSupply,
        });
        const serializedInitializeFundData = borsh.serialize(exports.schema, initializeFundData);
        const initializePoolRequest = new InitializePoolRequest({
            nonce,
            assetsLength: fundVaultAccounts.length,
            poolName,
            feeRate,
            customData: serializedInitializeFundData,
        });
        const poolRequest = new PoolRequest({
            tag: PoolRequestTag,
            index: 0,
            inner: initializePoolRequest,
        });
        const serializedData = borsh.serialize(exports.schema, poolRequest);
        return new web3_js_1.TransactionInstruction({
            keys,
            programId: fundProgramId,
            data: Buffer.from(serializedData.buffer, serializedData.byteOffset, serializedData.byteLength),
        });
    }
    static createExecuteInstruction(fundProgramId, fundAccount, fundTokenMint, fundVaultAccounts, fundVaultAuthority, userPoolTokenAccount, userAssetsAccounts, authorityUserAccounts, lqdFeeAccount, initializerFeeAccount, refferFeeVault, tokenProgramId, amount) {
        return Fund.createPoolActionInstruction(fundProgramId, fundAccount, fundTokenMint, fundVaultAccounts, fundVaultAuthority, userPoolTokenAccount, userAssetsAccounts, authorityUserAccounts, lqdFeeAccount, initializerFeeAccount, refferFeeVault, tokenProgramId, PoolAction.Create, amount);
    }
    static createRedeemInstruction(fundProgramId, fundAccount, fundTokenMint, fundVaultAccounts, fundVaultAuthority, userPoolTokenAccount, userAssetsAccounts, authorityUserAccounts, lqdFeeAccount, initializerFeeAccount, refferFeeVault, tokenProgramId, amount) {
        return Fund.createPoolActionInstruction(fundProgramId, fundAccount, fundTokenMint, fundVaultAccounts, fundVaultAuthority, userPoolTokenAccount, userAssetsAccounts, authorityUserAccounts, lqdFeeAccount, initializerFeeAccount, refferFeeVault, tokenProgramId, PoolAction.Redeem, amount);
    }
    static createPoolActionInstruction(fundProgramId, fundAccount, fundTokenMint, fundVaultAccounts, fundVaultAuthority, userPoolTokenAccount, userAssetsAccounts, authorityUserAccounts, lqdFeeAccount, initializerFeeAccount, refferFeeVault, tokenProgramId, poolActionType, amount) {
        const keys = [
            { pubkey: fundAccount, isSigner: false, isWritable: true },
            { pubkey: fundTokenMint, isSigner: false, isWritable: true },
            ...fundVaultAccounts.map((acc) => ({ pubkey: acc, isSigner: false, isWritable: true })),
            { pubkey: fundVaultAuthority, isSigner: false, isWritable: false },
            { pubkey: userPoolTokenAccount, isSigner: false, isWritable: true },
            ...userAssetsAccounts.map((acc) => ({ pubkey: acc, isSigner: false, isWritable: true })),
            { pubkey: authorityUserAccounts, isSigner: true, isWritable: false },
            { pubkey: lqdFeeAccount, isSigner: false, isWritable: true },
            { pubkey: initializerFeeAccount, isSigner: false, isWritable: true },
            { pubkey: refferFeeVault, isSigner: false, isWritable: true },
            { pubkey: tokenProgramId, isSigner: false, isWritable: false },
        ];
        const executePoolAction = new ExecutePoolAction({
            index: poolActionType,
            amount,
        });
        const poolRequest = new PoolRequest({
            tag: PoolRequestTag,
            index: 2,
            inner: executePoolAction,
        });
        const serializedData = borsh.serialize(exports.schema, poolRequest);
        return new web3_js_1.TransactionInstruction({
            keys,
            programId: fundProgramId,
            data: Buffer.from(serializedData.buffer, serializedData.byteOffset, serializedData.byteLength),
        });
    }
    static decodePoolState(buffer) {
        const poolState = borsh.deserialize(exports.schema, PoolState, buffer);
        const fundState = borsh.deserialize(exports.schema, FundState, Buffer.from(poolState.customState));
        poolState.fundState = fundState;
        return poolState;
    }
}
exports.Fund = Fund;
